import { render, staticRenderFns } from "./OrganisationSection.vue?vue&type=template&id=0d2e4355&"
import script from "./OrganisationSection.vue?vue&type=script&lang=js&"
export * from "./OrganisationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports